import React from "react";

const SmokingFree = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M8.59961 13V17M16.5996 5V5.5C16.5996 6.03043 16.8103 6.53914 17.1854 6.91421C17.5605 7.28929 18.0692 7.5 18.5996 7.5C19.13 7.5 19.6387 7.71071 20.0138 8.08579C20.3889 8.46086 20.5996 8.96957 20.5996 9.5V10M3.59961 3L21.5996 21M17.5996 13H20.5996C20.8648 13 21.1192 13.1054 21.3067 13.2929C21.4943 13.4804 21.5996 13.7348 21.5996 14V16C21.5996 16.28 21.4846 16.533 21.2996 16.714M17.5996 17H4.59961C4.33439 17 4.08004 16.8946 3.8925 16.7071C3.70497 16.5196 3.59961 16.2652 3.59961 16V14C3.59961 13.7348 3.70497 13.4804 3.8925 13.2929C4.08004 13.1054 4.33439 13 4.59961 13H13.5996"
        stroke="#00A3BC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SmokingFree;
